module.exports = __webpack_public_path__ + "img/ico-wallet.8631a454.svg";